var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDailyCmsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 166,
    viewBox: "0 0 214 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.915 0.349609C96.4924 0.349609 78.641 7.08221 64.5454 18.3464H41.7643C38.8046 18.3464 36.383 20.776 36.383 23.7454C36.383 26.7149 38.8046 29.1445 41.7643 29.1445H53.3583H56.7557C59.7155 29.1445 62.1371 31.574 62.1371 34.5435C62.1371 36.0264 61.5308 37.3798 60.555 38.3552C59.5827 39.3342 58.2338 39.9425 56.7557 39.9425H49.5074H45.5051H25.979C23.0193 39.9425 20.5977 42.3721 20.5977 45.3416C20.5977 48.311 23.0193 50.7406 25.979 50.7406H39.9576C35.7379 60.6899 33.4006 71.6374 33.4006 83.1348C33.4006 87.3065 33.7092 91.4061 34.3011 95.4122C34.5486 97.0859 34.8464 98.7452 35.1944 100.387C45.3472 98.828 56.1171 97.5754 67.3606 96.6612L68.2072 97.4351L69.0037 96.5316C82.5109 95.477 96.689 94.9155 111.312 94.9155C142.38 94.9155 171.454 97.4495 196.312 101.855C197.27 97.687 197.916 93.4002 198.221 89.0162C198.361 87.0725 198.429 85.1109 198.429 83.1348C198.429 37.4122 161.488 0.349609 115.915 0.349609Z",
    fill: "#F1F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63818 39.6934H6.37694C3.3788 39.6934 0.925781 42.172 0.925781 45.2014C0.925781 48.2308 3.3788 50.7095 6.37694 50.7095H9.63818C12.6363 50.7095 15.0893 48.2308 15.0893 45.2014C15.0893 42.172 12.6363 39.6934 9.63818 39.6934Z",
    fill: "#F1F2F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_622_39911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 95,
    width: 179,
    height: 71
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.324 95.0352V165.592H124.203H35.082V95.0352H213.324Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_622_39911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.324 122.314C213.324 125.265 210.903 127.679 207.943 127.679H173.579C172.101 127.679 170.753 128.284 169.781 129.257C168.805 130.226 168.199 131.571 168.199 133.044C168.199 135.995 170.62 138.409 173.579 138.409H179.964C181.441 138.409 182.79 139.014 183.762 139.987C184.737 140.956 185.344 142.301 185.344 143.774C185.344 146.725 182.923 149.139 179.964 149.139H165.283C151.492 159.469 134.355 165.592 115.783 165.592C76.1176 165.592 42.9907 137.676 35.082 100.472C45.2324 98.923 55.9997 97.6783 67.2405 96.7698L68.0866 97.5388L68.8832 96.6411C82.3868 95.5931 96.5618 95.0352 111.181 95.0352C142.242 95.0352 171.308 97.5531 196.161 101.931C194.952 107.146 193.245 112.167 191.093 116.949H207.943C209.425 116.949 210.766 117.554 211.742 118.527C212.717 119.496 213.324 120.841 213.324 122.314Z",
    fill: "#E8EBF2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.268 108.754H87.7034V42.9395C87.7034 42.4754 87.3237 42.0957 86.8596 42.0957H80.9532C80.4891 42.0957 80.1094 42.4754 80.1094 42.9395V115.504C80.1094 115.969 80.4891 116.348 80.9532 116.348H160.268C160.732 116.348 161.112 115.969 161.112 115.504V109.598C161.112 109.134 160.732 108.754 160.268 108.754ZM98.8624 92.4799C99.1893 92.8068 99.7167 92.8068 100.054 92.4799L114.641 77.9669L128.099 91.5095C128.426 91.8365 128.964 91.8365 129.291 91.5095L158.338 62.473C158.665 62.146 158.665 61.6081 158.338 61.2811L154.162 57.1044C154.003 56.9474 153.789 56.8593 153.566 56.8593C153.342 56.8593 153.128 56.9474 152.97 57.1044L128.711 81.3525L115.274 67.831C115.115 67.6739 114.901 67.5858 114.678 67.5858C114.455 67.5858 114.241 67.6739 114.082 67.831L94.6962 87.1008C94.5392 87.2593 94.4511 87.4735 94.4511 87.6967C94.4511 87.9198 94.5392 88.134 94.6962 88.2926L98.8624 92.4799Z",
    fill: "#A9A9A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5972 96.3477L67.834 97.1345L67.0234 96.4605C67.5454 96.4197 68.0714 96.3821 68.5972 96.3477Z",
    fill: "#F1F2F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9297 110.905C69.9297 113.403 70.7288 115.729 72.1022 117.688L70.6446 122.912L76.3198 121.531C78.4535 122.772 80.9836 123.494 83.6998 123.494C91.305 123.494 97.4699 117.857 97.4699 110.905C97.4699 103.951 91.305 98.3145 83.6998 98.3145C76.0946 98.3145 69.9297 103.951 69.9297 110.905Z",
    fill: "url(#paint0_linear_622_39911)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2422 110.904C87.2422 111.773 87.9463 112.478 88.8157 112.478C89.6847 112.478 90.3896 111.773 90.3896 110.904C90.3896 110.035 89.6847 109.33 88.8157 109.33C87.9463 109.33 87.2422 110.035 87.2422 110.904Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5234 110.904C82.5234 111.773 83.2279 112.478 84.0972 112.478C84.966 112.478 85.6709 111.773 85.6709 110.904C85.6709 110.035 84.966 109.33 84.0972 109.33C83.2279 109.33 82.5234 110.035 82.5234 110.904Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0117 110.904C77.0117 111.773 77.7162 112.478 78.5854 112.478C79.4543 112.478 80.1592 111.773 80.1592 110.904C80.1592 110.035 79.4543 109.33 78.5854 109.33C77.7162 109.33 77.0117 110.035 77.0117 110.904Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.067 149.067C193.037 149.067 190.559 146.588 190.559 143.559C190.559 140.529 193.037 138.051 196.067 138.051C199.096 138.051 201.575 140.529 201.575 143.559C201.575 146.588 199.096 149.067 196.067 149.067Z",
    fill: "#E1E3EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_39911",
    x1: 69.9297,
    y1: 110.904,
    x2: 97.4699,
    y2: 110.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCmsIcon);
export default __webpack_public_path__ + "static/media/daily-cms-icon.9cfbd09b1546d0a5b3002bb0ca6062be.svg";
export { ForwardRef as ReactComponent };